import shortid from 'shortid';
import QueryBuilder from '@/components/query2/query-builder';

export default class FilterTab {
    static defaultLabel = 'Custom Search';

    label = null;

    readOnly = false;

    systemTab = false;

    filter = null;

    criteria = null;

    offset = null;

    sortBy = null;

    defaultSortBy = null; // the default sortBy settings (tabs-configuration settings in the app)

    active = false;

    position = null;

    uid = `tab-${shortid.generate()}`;

    constructor({
        label = FilterTab.defaultLabel,
        filter = null,
        criteria = null,
        offset = null,
        sortBy = null,
        defaultSortBy = null,
        readOnly = false,
        systemTab = false,
        uid = null,
        active = false,
        position = null,
    }) {
        this.label = label;
        this.readOnly = readOnly;
        this.active = active;
        this.systemTab = systemTab;
        this.sortBy = sortBy;
        this.defaultSortBy = defaultSortBy;
        this.position = position;
        if (offset) {
            this.offset = offset;
        }
        if (filter) {
            this.filter = filter;
        }
        if (criteria) {
            this.criteria = criteria;
        }
        if (uid) {
            this.uid = uid;
        }
    }

    setCriteria(criteria) {
        this.criteria = criteria;
    }

    setFilter(filter) {
        this.filter = filter;
    }

    setSort(sortBy) {
        this.sortBy = sortBy;
    }

    getStringFilter(filterSet) {
        return QueryBuilder.convertQueryToFilterString({filterSet, query: this.filter});
    }
}
